// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "*[data-v-2b30220c]{box-sizing:border-box}.tab-body[data-v-2b30220c]{max-height:0;overflow:hidden;background:#fff}.tab-body.active[data-v-2b30220c]{max-height:100%;overflow-y:auto}.tab-body.fixed[data-v-2b30220c]{position:absolute;left:0;top:0;width:100%;overflow-x:auto;height:calc(100% - 35px)}", ""]);
// Exports
module.exports = exports;
